
import { endpoints } from "../api"
import { setLoading, setSignupData } from "../../slices/AuthSlice";
import toast from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import { setToken } from "../../slices/AuthSlice";
import { setPermissions, setUser } from '../../slices/ProfileSlice'
import { SetSignupData } from '../../slices/AuthSlice'
import { message } from '../../messages/Message'


const { GET_STARTED_API,
  REGISTER_API,
  LOGIN_API,
  API_URL,
  RESEND_API,
  FORGET_PASSWORD_API,
  CHANGE_PASSWORD_API,
  APP_URL_CHECK_API,
  CREATE_TEAM,
  UPDATE_PASSWORD,
  LOGOUT_API

} = endpoints;


export function getStarted(
  payload,
  navigate, email
) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", GET_STARTED_API, payload)
      if (response?.status === 200) {
        dispatch(setLoading(false))
        dispatch(setSignupData(payload))
        const encodedEmail = btoa(email);
        navigate(`/verify-email?data=${encodeURIComponent(encodedEmail)}`);
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.data?.status === 422) {
        toast.error(error.response.data.errors.email[0]);
      }

      if (error?.response?.data?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}


export function Register(
  payload,
  navigate
) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", REGISTER_API, payload)
      if (response?.status === 200) {
        dispatch(setSignupData(response.data.user))
        dispatch(setLoading(false));
        navigate("/registration-success")
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.data?.status === 403) {
        toast.error(error.response.data.message);
      }
      if (error?.response?.data?.status === 422) {
        const errors = error.response.data.errors;

        if (errors.email) {
          toast.error(errors.email[0]);
        }

        if (errors.app_url) {
          toast.error(errors.app_url[0]);
        }
        if (errors.company_name) {
          toast.error(errors.company_name[0]);
        }
      }

      if (error?.response?.data?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function Login(
  payload,
  navigate
) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", LOGIN_API, payload)
      if (response?.status === 200) {
        dispatch(setToken(response?.data?.access_token))
        const appUrl = response?.data?.user?.business.app_url;
        const userImage = response?.data?.user?.profile_image
          ? response.data.user.profile_image
          : `https://api.dicebear.com/5.x/initials/svg?seed=${response.data.user.name}`

        const permissionPaths = response?.data?.user?.roles.flatMap((role) =>
          role.permissions?.map((perm) => perm.path)
        );
        dispatch(setUser({ ...response.data.user, profile_image: userImage }))
        dispatch(setPermissions(permissionPaths));
        localStorage.setItem("sidebarOpen", "true")
        localStorage.setItem("token", JSON.stringify(response.data.access_token))
        localStorage.setItem("user", JSON.stringify({ ...response.data.user, profile_image: userImage }))
        localStorage.setItem("permissions", JSON.stringify(permissionPaths))
        dispatch(setLoading(false))
        toast.success(message.loginSuccess)
        navigate("/business-dashboard")
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.data?.status === 401) {
        toast.error(error.response.data.message);
      }
      if (error?.response?.data?.status === 403) {
        toast.error(error.response.data.message);
      }
      if (error?.response?.data?.status === 429) {
        toast.error(error.response.data.message);
      }

      if (error?.response?.data?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}


export function logoutApi(token, navigate) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", LOGOUT_API, '', { 'Authorization': `Bearer ${token}` })


      if (response?.status === 200) {
        dispatch(setLoading(false))
        dispatch(setToken(null))
        dispatch(setUser(null))
        localStorage.removeItem("token")
        localStorage.removeItem("user")
        localStorage.removeItem("permissions");
        localStorage.removeItem("urlLink");
        toast.success(response.data.message)
        navigate("/login")
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        dispatch(setToken(null))
        dispatch(setUser(null))
        localStorage.removeItem("token")
        localStorage.removeItem("user")
        localStorage.removeItem("permissions");
        localStorage.removeItem("urlLink");
        dispatch(setLoading(false))
        navigate('/login')
      }
      else {
        dispatch(setLoading(false))
        toast.error(message.errorMessage)
      }
    }
  }
}


export function apiUrl(
) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("GET", API_URL, "")
      if (response?.status === 200) {
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.data?.status === 401) {
        toast.error(error.response.data.message);
      }

      if (error?.response?.data?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}



export function resendEmail(
  payload
) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", RESEND_API, payload)
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message)
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.data?.status === 404) {
        toast.error(error.response.data.message);
      }
      if (error?.response?.data?.status === 400) {
        toast.error(error.response.data.message);
      }

      if (error?.response?.data?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}


export function forgetPassword(
  payload
) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", FORGET_PASSWORD_API, payload)
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message)
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 404) {
        toast.error(error.response.data.message);
      }
      if (error?.response?.status === 422) {
        toast.error(error.response.data.message);
      }
      if (error?.response?.status === 403) {
        toast.error(error.response.data.message);
      }

      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function resetPassword(
  payload,
  navigate
) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", CHANGE_PASSWORD_API, payload)
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message)
        navigate("/login")
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
        toast.error(error.response.data.message);
      }
      if (error?.response?.status === 422) {
        toast.error(error.response.data.message);
      }
    }
  }
}


export function AppCheckUrl(
  payload
) {
  return async (dispatch) => {
    try {
      const response = await apiConnector("POST", APP_URL_CHECK_API, payload)
      if (response?.status === 200) {
        return response;
      }
    } catch (error) {

      if (error?.response?.status === 500) {
        return error.response;
      }
    }
  }
}

export function CreateTeam(
  payload,
  token,
  onClose
) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", CREATE_TEAM, payload, { 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message)
        onClose()
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.data?.status === 422) {
        toast.error(error.response.data.errors.email[0]);
        onClose()
      }


      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
        onClose()
      }
    }
  }
}

export function updatePassword(
  payload,
  navigate
) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", UPDATE_PASSWORD, payload)
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message)
        navigate("/login")
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
        toast.error(error.response.data.message);
      }
      if (error?.response?.status === 422) {
        toast.error(error.response.data.message);
      }

      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}



